import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import { Button } from 'reactstrap';

import { connect } from 'react-redux';

import { toastr } from 'react-redux-toastr';

import Modal from '../../../common/modal/Modal';

import {
  getItinerarySupplierFood,
  putItinerarySupplierFoodQuantityCost,
} from '../../../../actions/food/ItinerarySupplierFood';

import EditItinerarySupplierFoodForm from './EditItinerarySupplierFoodForm';

export const EditItineraryFoodButton = ({
  itinerarySupplierFood,
  dispatchGetItinerarySupplierFood,
  dispatchPutItinerarySupplierFoodQuantityCost,
}) => {
  const [showModal, setShowModal] = useState(false);

  const [loading, setLoading] = useState(false);

  const [currentItinerarySupplierFood, setCurrentItinerarySupplierFood] =
    useState(itinerarySupplierFood);

  useEffect(() => {
    setCurrentItinerarySupplierFood(itinerarySupplierFood);
  }, [itinerarySupplierFood]);

  const openModal = (e) => {
    if (e) {
      e.stopPropagation();
    }

    if (loading) {
      return;
    }

    setShowModal(true);
  };

  const closeModal = () => {
    if (loading) {
      return;
    }

    setShowModal(false);
  };

  const handleSubmit = async (formValues) => {
    const { itinerarySupplierFoodDetailList = [] } = formValues;

    const payload = itinerarySupplierFoodDetailList.map((item) => ({
      id: item.id,
      quantity: Number(item.quantity),
      cost: Number(item.cost),
    }));

    setLoading(true);

    try {
      const response = await dispatchPutItinerarySupplierFoodQuantityCost(
        payload,
      );

      if (!response || response.length === 0) {
        return;
      }

      /*
       * Después de actualizar, volvemos a consultar
       * toda la alimentación desde backend.
       */
      await dispatchGetItinerarySupplierFood({
        itinerarySupplierFoodId: currentItinerarySupplierFood.id,
      });

      toastr.success('Éxito', 'La alimentación fue actualizada correctamente.');

      setShowModal(false);
    } finally {
      setLoading(false);
    }
  };

  const detailList =
    currentItinerarySupplierFood &&
    Array.isArray(currentItinerarySupplierFood.itinerarySupplierFoodDetailList)
      ? currentItinerarySupplierFood.itinerarySupplierFoodDetailList
      : [];

  const initialValues = {
    itinerarySupplierFoodDetailList: detailList.map((item) => {
      const quantity = Number(item.quantity) || 0;

      const totalCost = Number(item.cost) || 0;

      const unitCost =
        quantity > 0 ? Number((totalCost / quantity).toFixed(2)) : 0;

      return {
        ...item,

        food:
          item.food && item.food.id
            ? {
                ...item.food,
                value: item.food.id,
                label: item.food.name,
              }
            : item.food,

        quantity,

        unitCost,

        cost: Number(totalCost.toFixed(2)),
      };
    }),
  };

  return (
    <>
      <Button color="warning" onClick={openModal} disabled={loading}>
        {loading ? (
          <>
            <i className="fa fa-spinner fa-spin" /> Guardando...
          </>
        ) : (
          <>
            <i className="fa fa-pencil" /> Editar alimentación
          </>
        )}
      </Button>

      <Modal
        show={showModal}
        title="Editar alimentación"
        body={
          <EditItinerarySupplierFoodForm
            initialValues={initialValues}
            handleProcess={handleSubmit}
            onCancel={closeModal}
            loading={loading}
          />
        }
        size="xl"
        onClickCancel={closeModal}
        onClickClose={closeModal}
      />
    </>
  );
};

EditItineraryFoodButton.propTypes = {
  itinerarySupplierFood: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,

    itinerarySupplierFoodDetailList: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

        quantity: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

        cost: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

        food: PropTypes.shape({
          id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

          name: PropTypes.string,
        }),
      }),
    ),
  }).isRequired,

  dispatchGetItinerarySupplierFood: PropTypes.func.isRequired,

  dispatchPutItinerarySupplierFoodQuantityCost: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchGetItinerarySupplierFood: getItinerarySupplierFood,

  dispatchPutItinerarySupplierFoodQuantityCost:
    putItinerarySupplierFoodQuantityCost,
};

const connectedComponent = connect(
  null,
  mapDispatchToProps,
)(EditItineraryFoodButton);

export default connectedComponent;
